import { config } from '@app/config';

if (config.isNodeDev) {
  window.onerror = (event, source, lineno, colno, err) => {
    // must be within function call because that's when the element is defined for sure.
    const ErrorOverlay = customElements.get('vite-error-overlay');
    // don't open outside vite environment
    if (!ErrorOverlay) {
      return;
    }
    const overlay = new ErrorOverlay(err);
    document.body.appendChild(overlay);
  };
}

(console as any)._info = console.info;

console.info = function (msg: any) {
  (console as any)._info('%c[i]%c ', 'background: #000848; color: #FFF', 'color: #000848', msg);
};
